<template>
	<div class="veiculos-page">
		<div class="breadcrumb-bar">
			<span class="breadcrumb">Veículos / Documentação</span>
			<button class="back-btn" @click="voltar">
				<v-icon left size="20" color="white">mdi-undo</v-icon>
				Voltar
			</button>
		</div>
		<div class="conteudo">
			<v-card class="veiculos-table-card" outlined>
				<v-data-table
					class="veiculo-table"
					:headers="headers"
					:items="veiculos"
					:loading="loading"
					loading-text="Carregando veículos..."
					no-data-text="Nenhum veículo cadastrado"
					no-results-text="Nenhum resultado encontrado. Por favor, tente outra pesquisa."
					:items-per-page="8"
					:footer-props="footerProps"
				>
					<template v-slot:[`item.status`]="{ item }">
						<span class="documento-status" :class="isStatusAtivo(item.status) ? 'is-active' : 'error--text'">
							{{ formatStatus(item.status) }}
						</span>
					</template>
					<template v-slot:[`item.crlv`]="{ item }">
						<span v-if="item.crlv_data" :class="['doc-link', { 'doc-link--expired': isExpired(item.crlv_data) }]" @click="abrirDialog(item, 'crlv')">{{ item.crlv_data | datebr }}</span>
						<v-icon v-else color="#10b981" class="doc-edit-icon" @click="abrirDialog(item, 'crlv')">mdi-pencil</v-icon>
					</template>
					<template v-slot:[`item.antt`]="{ item }">
						<span v-if="item.antt_data" :class="['doc-link', { 'doc-link--expired': isExpired(item.antt_data) }]" @click="abrirDialog(item, 'antt')">{{ item.antt_data | datebr}}</span>
						<v-icon v-else color="#10b981" class="doc-edit-icon" @click="abrirDialog(item, 'antt')">mdi-pencil</v-icon>
					</template>
					<template v-slot:[`item.seguros`]="{ item }">
						<span v-if="item.seguros_data" :class="['doc-link', { 'doc-link--expired': isExpired(item.seguros_data) }]" @click="abrirDialog(item, 'seguros')">{{ item.seguros_data | datebr}}</span>
						<v-icon v-else color="#10b981" class="doc-edit-icon" @click="abrirDialog(item, 'seguros')">mdi-pencil</v-icon>
					</template>
					<template v-slot:[`item.acoes`]="{ item }">
						<v-menu offset-y left>
							<template v-slot:activator="{ on, attrs }">
								<v-btn icon small class="doc-actions" v-bind="attrs" v-on="on">
									<v-icon color="#10b981">mdi-dots-vertical</v-icon>
								</v-btn>
							</template>
							<v-list dense class="doc-actions__menu">
								<v-list-item @click="abrirDialog(item, 'crlv')">
									<v-list-item-icon>
										<v-icon color="#10b981" size="18">mdi-file-document-outline</v-icon>
									</v-list-item-icon>
									<v-list-item-title>CRLV</v-list-item-title>
								</v-list-item>
								<v-list-item @click="abrirDialog(item, 'antt')">
									<v-list-item-icon>
										<v-icon color="#10b981" size="18">mdi-file-document-outline</v-icon>
									</v-list-item-icon>
									<v-list-item-title>ANTT</v-list-item-title>
								</v-list-item>
								<v-list-item @click="abrirDialog(item, 'seguros')">
									<v-list-item-icon>
										<v-icon color="#10b981" size="18">mdi-file-document-outline</v-icon>
									</v-list-item-icon>
									<v-list-item-title>SEGUROS</v-list-item-title>
								</v-list-item>
							</v-list>
						</v-menu>
					</template>
				</v-data-table>
			</v-card>

			<v-dialog v-model="dialogOpen" max-width="600" persistent>
				<v-card class="doc-dialog" outlined>
					<v-card-title class="doc-dialog__title">
						<span>{{ dialogTitle }}</span>
						<v-spacer />
						<v-btn icon @click="closeDialog">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-divider />
					<v-card-text class="pt-6 pb-0">
						<div class="doc-cadastro-bar">
							<v-btn class="doc-cadastro-btn" color="#10b981" dark @click="toggleCadastroDialog">
								<v-icon left size="18">mdi-plus</v-icon>
								Cadastrar
							</v-btn>
						</div>
						<v-expand-transition>
							<div v-if="cadastroDialogOpen" class="doc-cadastro-form">
								<v-form ref="cadastroForm" v-model="cadastroFormValid" lazy-validation>
									<v-text-field v-model="cadastroData.validade" label="Validade" type="date" outlined dense />
									<v-file-input
										v-model="cadastroData.arquivo"
										label="Arquivo"
										outlined
										dense
										:rules="[v => !!v || 'Selecione um arquivo']"
										accept="application/pdf,image/*"
									/>
									<v-btn class="doc-cadastro-btn" color="#10b981" dark :loading="cadastroSaving" :disabled="cadastroSaving" @click="cadastrarDocumento">Salvar</v-btn>
									<v-btn text @click="toggleCadastroDialog">Cancelar</v-btn>
								</v-form>
							</div>
						</v-expand-transition>
						<v-data-table
							class="doc-historico-table"
							:headers="historicoHeaders"
							:items="historico"
							:loading="historicoLoading"
							loading-text="Carregando histórico..."
							no-data-text="Nenhum documento encontrado"
							hide-default-footer
						>
							<template v-slot:[`item.acoes`]='{ item }'>
								<v-btn
									icon
									small
									color="error"
									:loading="excluindoDocumentoId === item.id"
									:disabled="excluindoDocumentoId === item.id"
									@click="excluirDocumento(item)"
								>
									<v-icon size="18">mdi-delete</v-icon>
								</v-btn>
							</template>
							<template v-slot:[`item.data_envio`]="{ item }">
								<span>{{ item.data_envio | datebr}}</span>
							</template>
							<template v-slot:[`item.validade`]="{ item }">
								<span>{{ item.validade | datebr }}</span>
							</template>
							<template v-slot:[`item.nome_arquivo`]="{ item }">
								<span>{{ item.nome_arquivo }}</span>
								<v-btn icon small @click="baixarDocumento(item)">
									<v-icon color="#10b981">mdi-download</v-icon>
								</v-btn>
							</template>
						</v-data-table>
					</v-card-text>
					<v-card-actions class="px-6 pb-6">
						<v-spacer />
						<v-btn text @click="closeDialog">Fechar</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</div>
	</div>
</template>

<script>
import documentacaoServices from './documentacaoServices';

export default {
	name: 'DocumentacaoVeiculo',
	data() {
		return {
			loading: false,
			veiculos: [],
			dialogOpen: false,
			dialogTipo: '',
			dialogVeiculo: null,
			historico: [],
			historicoLoading: false,
			cadastroDialogOpen: false,
			cadastroFormValid: false,
			cadastroSaving: false,
			excluindoDocumentoId: null,
			cadastroData: {
				validade: '',
				arquivo: null,
			},
			headers: [
				{ text: 'Placa', value: 'placa' },
				{ text: 'Tipo', value: 'tipo' },
				{ text: 'Status', value: 'status' },
				{ text: 'CRLV', value: 'crlv', sortable: false },
				{ text: 'ANTT', value: 'antt', sortable: false },
				{ text: 'Seguro', value: 'seguros', sortable: false },
				{ text: 'Ações', value: 'acoes', sortable: false },
			],
			footerProps: {
				itemsPerPageText: 'Itens por Página',
				itemsPerPageOptions: [8, 15, 20],
				pageText: '{0}-{1} de {2}'
			},
			historicoHeaders: [
				{ text: '', value: 'acoes', sortable: false, width: 60 },
				{ text: 'Data de Envio', value: 'data_envio', sortable: false },
				{ text: 'Validade', value: 'validade', sortable: false },
				{ text: 'Nome do Arquivo', value: 'nome_arquivo', sortable: false },
			],
		};
	},
	computed: {
		dialogTitle() {
			if (!this.dialogVeiculo) return 'Documento';
			const tipoMap = {
				crlv: 'CRLV',
				antt: 'ANTT',
				seguros: 'Seguro',
			};
			return `Histórico - ${tipoMap[this.dialogTipo] || 'Documento'} (${this.dialogVeiculo.placa})`;
		},
	},
	methods: {
		isStatusAtivo(status) {
			const normalized = String(status || '').trim().toUpperCase();
			return normalized === 'ATIVO';
		},
		formatStatus(status) {
			const map = {
				ATIVO: 'Ativo',
				VENDIDO: 'Vendido',
				BAIXADO: 'Baixado',
				MANUTENCAO: 'Manutenção',
				'MANUTENÇÃO': 'Manutenção',
			};

			const normalized = String(status || '').trim().toUpperCase();
			return map[normalized] || status || '-';
		},

		isExpired(dateValue) {
			if (!dateValue) return false;

			const dataDocumento = new Date(dateValue);
			if (Number.isNaN(dataDocumento.getTime())) return false;

			const hoje = new Date();
			hoje.setHours(0, 0, 0, 0);
			dataDocumento.setHours(0, 0, 0, 0);

			return dataDocumento < hoje;
		},
		voltar() {
			this.$router.push('/veiculos');
		},
		async fetchVeiculos() {
			this.loading = true;
			try {
				const documentos = await documentacaoServices.listarDocumentos();
				this.veiculos = Array.isArray(documentos) ? documentos : [];
			} catch (e) {
				this.veiculos = [];
			}
			this.loading = false;
		},
		async abrirDialog(item, tipo) {
			this.dialogVeiculo = item;
			this.dialogTipo = tipo;
			this.dialogOpen = true;
			this.historico = [];
			this.historicoLoading = true;
			try {
				const historico = await documentacaoServices.historicoDocumento(item.id, tipo);
				this.historico = Array.isArray(historico) ? historico : [];
			} catch (e) {
				this.historico = [];
			}
			this.historicoLoading = false;
		},
		closeDialog() {
			this.dialogOpen = false;
			this.dialogVeiculo = null;
			this.dialogTipo = '';
			this.historico = [];
			this.cadastroDialogOpen = false;
			this.cadastroData = {
				validade: '',
				arquivo: null,
			};
			this.cadastroSaving = false;
			this.excluindoDocumentoId = null;
			this.fetchVeiculos();
		},
		toggleCadastroDialog() {
			this.cadastroDialogOpen = !this.cadastroDialogOpen;
			if (!this.cadastroDialogOpen) {
				this.cadastroData = {
					validade: '',
					arquivo: null,
				};
				this.cadastroSaving = false;
			}
		},
		async cadastrarDocumento() {
			if (!this.$refs.cadastroForm?.validate?.()) return;
			if (!this.cadastroData.arquivo) return;
			this.cadastroSaving = true;
			try {
				const veiculo_id = this.dialogVeiculo?.id;
				const tipo = this.dialogTipo;
				const formData = new FormData();
				formData.append('arquivo', this.cadastroData.arquivo);
				formData.append('validade', this.cadastroData.validade || '');
				await documentacaoServices.cadastrarDocumento(veiculo_id, tipo, formData);
				this.$toasted?.show('Documentação cadastrada com sucesso!');
				this.toggleCadastroDialog();
				await this.abrirDialog(this.dialogVeiculo, tipo);
			} catch (e) {
				this.$toasted?.show('Erro ao cadastrar documentação');
			}
			this.cadastroSaving = false;
		},
		async baixarDocumento(item) {
			try {
				const veiculo_id = this.dialogVeiculo?.id;
				const tipo = this.dialogTipo;
				const documento_id = item.id;
				const response = await documentacaoServices.baixarDocumento(veiculo_id, tipo, documento_id);
				const blob = new Blob([response.data], { type: response.headers['content-type'] });
				const url = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', item.nome_arquivo || 'documento.pdf');
				document.body.appendChild(link);
				link.click();
				link.remove();
				window.URL.revokeObjectURL(url);
			} catch (e) {
				this.$toasted?.show('Erro ao baixar documento');
			}
		},
		async excluirDocumento(item) {
			const confirmar = window.confirm('Deseja realmente excluir este documento?');
			if (!confirmar) return;

			try {
				this.excluindoDocumentoId = item.id;
				const veiculo_id = this.dialogVeiculo?.id;
				const tipo = this.dialogTipo;
				const documento_id = item.id;

				await documentacaoServices.excluirDocumento(veiculo_id, tipo, documento_id);
				this.$toasted?.show('Documento excluído com sucesso!');
				await this.abrirDialog(this.dialogVeiculo, tipo);
			} catch (e) {
				this.$toasted?.show('Erro ao excluir documento');
			}

			this.excluindoDocumentoId = null;
		},
	},
	mounted() {
		this.fetchVeiculos();
	},
};
</script>

<style>
@import "../../assets/inter-font.css";

.veiculos-page {
	background: #fff;
	font-family: "Inter", sans-serif;
	color: #1f2a44;
	padding: 24px;
}
.breadcrumb-bar {
	display: flex;
	justify-content: space-between;
	align-items: center;
	border-bottom: 1px solid #e0e0e0;
	padding-bottom: 12px;
	margin-bottom: 24px;
}
.breadcrumb {
	font-size: 1.1em;
	color: #10b981;
	font-weight: 800;
}
.back-btn {
	background: #10b981;
	color: #fff;
	border: none;
	border-radius: 8px;
	padding: 6px 12px;
	cursor: pointer;
	font-size: 0.95em;
	font-weight: 600;
	transition: background 0.2s;
}
.back-btn:hover {
	background: #0e9e6c;
}

.conteudo {
	margin-top: 24px;
}
.veiculos-table-card {
	border-radius: 16px !important;
	border-color: #e6ebf1 !important;
}
.veiculo-table {
	border-radius: 16px !important;
}

.veiculo-table ::v-deep th {
	color: #7a8ca6 !important;
	font-weight: 800 !important;
	font-size: 11px !important;
	letter-spacing: 0.08em !important;
}

.veiculo-table ::v-deep td {
	color: #1f2a44 !important;
	font-size: 13px !important;
}

.veiculo-table ::v-deep .v-data-table__wrapper {
	border-radius: 16px !important;
}

.doc-link {
	color: #10b981;
	cursor: pointer;
	font-weight: 600;
	transition: color 0.2s;
}
.doc-link:hover {
	color: #0e9e6c;
	text-decoration: underline;
}
.doc-link--expired {
	color: #ef4444;
}
.doc-link--expired:hover {
	color: #dc2626;
}
.doc-edit-icon {
	cursor: pointer;
	vertical-align: middle;
}
.doc-edit-icon:hover {
	color: #0e9e6c;
}
.doc-actions {
	opacity: 0.9;
}
.doc-actions__menu {
	min-width: 180px;
}
.doc-dialog__title {
	font-weight: 800;
	color: #10b981;
}
.doc-dialog {
	border-radius: 16px;
}
.doc-cadastro-bar {
	display: flex;
	justify-content: flex-end;
	margin-bottom: 12px;
}
.doc-cadastro-btn {
	background: #10b981 !important;
	color: #fff !important;
	border-radius: 8px;
	font-weight: 700;
	text-transform: none;
	margin-bottom: 8px;
}
.doc-cadastro-form {
	background: #f6f8fa;
	border-radius: 12px;
	padding: 16px;
	margin-bottom: 16px;
}

.documento-status.is-active {
	color: #10b981;
}
.documento-status.error--text {
	color: #841f1f;
}
</style>
